import { Flex, Tag, Typography } from "antd"
import React from "react"

const { Text } = Typography

interface PermissionsCardLabelProps {
  sectionKey: string
  enabled: number
  total: number
}

export const PermissionsCardLabel = ({
  sectionKey,
  enabled,
  total
}: PermissionsCardLabelProps) => {
  return (
    <Flex align="center" gap={10} className={"w-full"}>
      <Text strong className={"capitalize"}>
        {sectionKey.replace(/_/g, " ")}
      </Text>
      <Tag>
        {enabled}/{total}
      </Tag>
    </Flex>
  )
}
